// extracted by mini-css-extract-plugin
export default {"item":"Me2AoqVDFIADbknBiAzJ"};